document.addEventListener('DOMContentLoaded', () => {
	const bis_form = document.querySelector('form.notify-form');
	if (bis_form) {
		bis_form.addEventListener('submit', (e) => {
			e.preventDefault();
			// var myHeaders = new Headers();
			// myHeaders.append("Content-Type", "application/json");
      // append the date in this format 2024-06-12 to myHeaders
      const date = new Date();
      const year = date.getFullYear();
      const month = date.getMonth() + 1; // Months are zero-based
      const day = date.getDate();
      const formattedDate = `${year}-${month < 10 ? '0' : ''}${month}-${day < 10 ? '0' : ''}${day}`;
      // myHeaders.append("revision", formattedDate);



			const email = bis_form.querySelector('input[type="email"]').value;
			const formMessage = document.querySelector('.pg-oos-banner-form .form-message');
			const klaviyoAPIKey = bis_form.getAttribute('data-klaviyo-api-key');
			const productID = bis_form.getAttribute('data-product-id');
			const successMessage = bis_form.getAttribute('data-form-success-message');
			const errorMessage = bis_form.getAttribute('data-form-error-message');
			// var urlencoded = new URLSearchParams();
			// urlencoded.append("a", klaviyoAPIKey);
			// urlencoded.append("variant", productID);
			// urlencoded.append("platform", "shopify");
			// urlencoded.append("email", email);

      // insert the product ID in the payload
      const myHeaders = new Headers({
        "revision": "2024-07-15",
        "Content-Type": "application/json",
        "Accept": "application/json"
      });

      const raw = JSON.stringify({
        data: {
          type: "back-in-stock-subscription",
          attributes: {
            channels: ["EMAIL"],
            profile: {
              data: {
                type: "profile",
                attributes: {
                  email: email
                }
              }
            }
          },
          relationships: {
            variant: {
              data: {
                type: "catalog-variant",
                id: `$shopify:::$default:::${productID}`
              }
            }
          }
        }
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow"
      };

  fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${klaviyoAPIKey}`, requestOptions)
				.then(response => response.text())
				.then(result => {
						// Handle the success message here
						formMessage.style.marginTop = "20px";
						formMessage.innerText = successMessage;
						formMessage.classList.remove('error');
						formMessage.classList.add('success');
						console.log(result);
				})
				.catch(error => {
						// Handle the error message here
						formMessage.style.marginTop = "20px";
						formMessage.innerText = errorMessage;
						formMessage.classList.remove('success');
						formMessage.classList.add('error');
						console.log('error', error);
				});
		});
	}
});